/**
 * Finish-giant placements from `.dev/giant-positions/*.svg`
 * (authoring 13671×930), scaled onto art viewBox (6276×428).
 *
 * Mona uses the large mask frame (matches PNG crop); Mu centers the PNG
 * inside a wider path bbox; others use the named giant group bbox.
 */
import type { GiantId } from '../../../../domain/ids/ids';

export type LevelGiantPlacement = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export const LEVEL_GIANT_PLACEMENTS: Record<GiantId, LevelGiantPlacement> = {
  duck: { left: 5746.871, top: 101.666, width: 299.133, height: 215.131 },
  drakochi: { left: 5842.726, top: 126.503, width: 137.125, height: 184.063 },
  factor: { left: 5714.415, top: 4.125, width: 340.862, height: 331.636 },
  mona: { left: 5703.994, top: 104.929, width: 348.437, height: 212.619 },
  mu: { left: 5829.298, top: 104.304, width: 162.512, height: 236.09 },
  roza: { left: 5826.383, top: 106.491, width: 166.001, height: 174.504 },
  serj: { left: 5764.133, top: 102.926, width: 301.153, height: 240.702 },
  sol: { left: 5788.418, top: 101.73, width: 289.033, height: 224.854 },
  svami: { left: 5755.043, top: 144.952, width: 214.617, height: 244.191 },
  willy: { left: 5748.065, top: 124.806, width: 306.524, height: 186.756 },
  yetti: { left: 5728.003, top: 176.034, width: 374.604, height: 155.592 },
};
